export default __webpack_public_path__ + "static/media/runeofgrounding.0635208a.png";